import { r as e } from "./chunks/errors-BJxlOkXf.js";
import { normalizeApplicationCode as t, normalizeBasePath as n } from "./core.js";
import { n as r } from "./chunks/processInitiationViewContext-CRN1YTzW.js";
import { a as i, c as a, i as o, l as s, n as c, o as l, r as u, s as d, t as f } from "./chunks/formSessionValidation-CVWkHZ2j.js";
import { i as p, n as m, r as h, t as g } from "./chunks/formSessionClient-BWd29Jto.js";
import { n as _, r as v, t as y } from "./chunks/formSessionGuard-CQFBevBW.js";
import { createWorkflowWorkItemBridge as b } from "./workflow.js";
//#region src/shell/shellBridge.ts
var x = "platform:route-change", S = "platform:primary-navigation-select", C = class {
	options;
	disposed = !1;
	registeredPrimaryNavigationCodes = /* @__PURE__ */ new Set();
	routeListener = (e) => {
		let t = O(e, this.options.context.basePath);
		this.options.onRouteChange?.(t.path);
	};
	popStateListener = () => {
		let e = j((this.options.window ?? globalThis.window).location.pathname, this.options.context.basePath);
		this.options.onRouteChange?.(e);
	};
	primaryNavigationListener = (e) => {
		let t = w(e, this.options.context.applicationCode);
		t && this.registeredPrimaryNavigationCodes.has(t.navigationCode) && this.options.context.permissionCodes.includes(t.navigationCode) && this.options.onPrimaryNavigationSelect?.(t.navigationCode);
	};
	constructor(e) {
		this.options = e, e.context.runtimePurpose !== "form-session" && (e.context.mode === "embedded" ? (e.eventBus?.on(x, this.routeListener), e.eventBus?.on(S, this.primaryNavigationListener)) : (e.window ?? globalThis.window)?.addEventListener?.("popstate", this.popStateListener));
	}
	navigate(e, t) {
		this.assertActive();
		let n = A(e), { context: r } = this.options;
		if (r.mode === "embedded") {
			r.navigate?.(n), t && r.onPrimaryNavigationChange?.(t);
			return;
		}
		let i = `${r.basePath}${n}` || "/";
		(this.options.history ?? globalThis.history).pushState({}, "", i), this.options.onRouteChange?.(n);
	}
	primaryNavigationChanged(e) {
		if (this.assertActive(), !e.trim()) throw Error("navigationCode 不能为空");
		this.options.context.onPrimaryNavigationChange?.(e);
	}
	registerPrimaryNavigation(e) {
		this.assertActive();
		let t = T(e);
		this.options.context.runtimePurpose !== "form-session" && (this.registeredPrimaryNavigationCodes.clear(), t.forEach((e) => this.registeredPrimaryNavigationCodes.add(e.code)), this.options.context.registerPrimaryNavigation?.(t));
	}
	dispose() {
		this.disposed || (this.disposed = !0, this.registeredPrimaryNavigationCodes.clear(), this.options.context.runtimePurpose !== "form-session" && this.options.context.registerPrimaryNavigation?.([]), this.options.eventBus?.off(x, this.routeListener), this.options.eventBus?.off(S, this.primaryNavigationListener), (this.options.window ?? globalThis.window)?.removeEventListener?.("popstate", this.popStateListener));
	}
	assertActive() {
		if (this.disposed) throw new e("SDK_SHELL_DISPOSED", "Shell Bridge 已卸载");
	}
};
function w(e, n) {
	if (!e || typeof e != "object") throw D();
	let r = e;
	if (typeof r.applicationCode != "string") throw D();
	if (t(r.applicationCode) === t(n)) {
		if (typeof r.navigationCode != "string" || !E(r.navigationCode)) throw D();
		return Object.freeze({
			applicationCode: t(r.applicationCode),
			navigationCode: r.navigationCode.trim()
		});
	}
}
function T(e) {
	if (!Array.isArray(e)) throw D();
	if (!e.length) return Object.freeze([]);
	let t = /* @__PURE__ */ new Set(), n = e.map((e) => {
		if (!e || typeof e != "object" || Object.keys(e).some((e) => ![
			"code",
			"label",
			"order"
		].includes(e)) || !E(e.code) || typeof e.label != "string" || !e.label.trim() || !Number.isInteger(e.order) || !Number.isFinite(e.order) || t.has(e.code.trim())) throw D();
		let n = e.code.trim();
		return t.add(n), Object.freeze({
			code: n,
			label: e.label.trim(),
			order: e.order
		});
	}).sort((e, t) => e.order - t.order || e.code.localeCompare(t.code));
	return Object.freeze(n);
}
function E(e) {
	return /^[A-Z][A-Z0-9_]{1,159}$/.test(e.trim());
}
function D() {
	return new e("SDK_PRIMARY_NAVIGATION_INVALID", "一级导航运行时契约无效");
}
function O(e, t) {
	if (!e || typeof e != "object") throw k();
	let r = e;
	if (typeof r.basePath != "string" || n(r.basePath) !== n(t) || typeof r.path != "string") throw k();
	return Object.freeze({
		basePath: n(r.basePath),
		path: A(r.path)
	});
}
function k() {
	return new e("SDK_SHELL_ROUTE_INVALID", "Shell 路由事件越出当前应用路由基座");
}
function A(e) {
	let t = e.trim();
	if (!t.startsWith("/") || t.includes("..") || t.startsWith("//")) throw k();
	return t;
}
function j(e, t) {
	let r = n(t || "/");
	if (r && !e.startsWith(r)) throw k();
	return A(e.slice(r.length) || "/");
}
//#endregion
//#region src/shell/operationHost.ts
var M = class {
	context;
	bridge;
	disposed = !1;
	terminal;
	lifecycleTerminal;
	constructor(t) {
		if (this.context = t, !t.operationHost) throw new e("SDK_OPERATION_HOST_UNAVAILABLE", "当前运行上下文不是流程操作宿主页");
	}
	get pageRoute() {
		return this.context.operationHost.pageRoute;
	}
	reportReady(e = this.pageRoute) {
		this.assertActive(), this.assertRoute(e), !this.terminal && (this.terminal = "READY", this.context.operationHost.reportRouteReady(e));
	}
	reportFailed(t) {
		this.assertActive();
		let n = t.pageRoute ?? this.pageRoute;
		if (this.assertRoute(n), !/^[A-Z][A-Z0-9_]{2,63}$/.test(t.code)) throw new e("SDK_OPERATION_FAILURE_CODE_INVALID", "流程操作页失败码非法");
		let r = t.message.trim();
		if (!r || r.length > 300 || /[\r\n]/.test(r)) throw new e("SDK_OPERATION_FAILURE_MESSAGE_INVALID", "流程操作页失败消息非法");
		this.terminal || (this.terminal = "FAILED", this.context.operationHost.reportRouteFailed?.({
			pageRoute: n,
			code: t.code,
			message: r
		}));
	}
	register(t) {
		if (this.assertActive(), this.bridge) throw new e("SDK_OPERATION_BRIDGE_DUPLICATE", "流程操作页 Bridge 已注册");
		this.bridge = t, this.context.operationHost.registerBridge(t);
	}
	unregister() {
		this.bridge &&= (this.context.operationHost.registerBridge(), void 0);
	}
	dispose() {
		this.disposed ||= (this.unregister(), !0);
	}
	assertActive() {
		if (this.disposed) throw new e("SDK_OPERATION_HOST_DISPOSED", "流程操作宿主适配器已卸载");
	}
	reportCompleted(e) {
		if (this.assertActive(), this.lifecycleTerminal) return;
		let t = this.requireBusinessLifecycle(), n = N({
			...e,
			operationInvocationId: t.operationInvocationId
		});
		this.lifecycleTerminal = "COMPLETED", t.reportCompleted(n);
	}
	requestClose() {
		if (this.assertActive(), this.lifecycleTerminal) return;
		let e = this.requireBusinessLifecycle();
		this.lifecycleTerminal = "CLOSE_REQUESTED", e.requestClose(Object.freeze({ operationInvocationId: e.operationInvocationId }));
	}
	assertRoute(t) {
		if (!t.startsWith("/") || t.includes("..")) throw new e("SDK_OPERATION_ROUTE_INVALID", "流程操作页路由非法");
	}
	requireBusinessLifecycle() {
		let t = this.context.operationHost;
		if (!t.operationInvocationId || !t.reportCompleted || !t.requestClose) throw new e("SDK_OPERATION_LIFECYCLE_UNAVAILABLE", "当前操作宿主未提供业务完成与取消能力");
		return {
			operationInvocationId: t.operationInvocationId,
			reportCompleted: t.reportCompleted,
			requestClose: t.requestClose
		};
	}
};
function N(t) {
	if (!["SUCCEEDED", "SUCCEEDED_WITH_WARNING"].includes(t.status)) throw new e("SDK_OPERATION_COMPLETION_STATUS_INVALID", "业务操作完成状态非法");
	if (!P(t.businessObjectType, 160)) throw new e("SDK_OPERATION_OBJECT_TYPE_INVALID", "业务对象类型非法");
	if (!P(t.businessObjectPublicId, 200)) throw new e("SDK_OPERATION_OBJECT_ID_INVALID", "业务对象公开标识非法");
	let n = F(t.message, 300, "SDK_OPERATION_COMPLETION_MESSAGE_INVALID", "业务操作完成消息非法"), r = I(t.warningCode);
	if (t.refreshSuggested !== void 0 && typeof t.refreshSuggested != "boolean") throw new e("SDK_OPERATION_REFRESH_HINT_INVALID", "业务操作刷新提示非法");
	return Object.freeze({
		operationInvocationId: t.operationInvocationId,
		status: t.status,
		businessObjectType: t.businessObjectType.trim(),
		businessObjectPublicId: t.businessObjectPublicId.trim(),
		...n ? { message: n } : {},
		...r ? { warningCode: r } : {},
		...t.refreshSuggested === void 0 ? {} : { refreshSuggested: t.refreshSuggested }
	});
}
function P(e, t) {
	return typeof e == "string" && !!e.trim() && e.trim().length <= t && !/[\r\n]/.test(e);
}
function F(t, n, r, i) {
	if (t !== void 0) {
		if (!P(t, n)) throw new e(r, i);
		return t.trim();
	}
}
function I(t) {
	if (t !== void 0) {
		if (typeof t != "string" || !/^[A-Z][A-Z0-9_]{2,63}$/.test(t)) throw new e("SDK_OPERATION_WARNING_CODE_INVALID", "业务操作警告码非法");
		return t;
	}
}
function L(e) {
	return new M(e);
}
//#endregion
//#region src/shell/workflowPageHost.ts
var R = class {
	runtimeContext;
	bridge;
	bridgeAbort;
	bridgeSource;
	disposed = !1;
	terminal;
	saveCapability;
	constructor(t) {
		if (this.runtimeContext = t, !t.workflowPageHost || !r(t.workflowPageHost.pageRoute)) throw new e("SDK_WORKFLOW_CAPABILITY_INVALID", "当前运行上下文不是 Workflow 工作项页面");
	}
	get pageRoute() {
		return this.host.pageRoute;
	}
	get context() {
		return this.host.context;
	}
	registerBridge(e) {
		if (this.assertActive(), this.context.recipientType === "CC" || this.terminal || this.bridge) throw V();
		if (e.signal?.aborted) throw this.failFromSourceAbort(), H();
		let t = new AbortController(), n = e.signal ? AbortSignal.any([t.signal, e.signal]) : t.signal, r;
		if (r = b({
			context: this.context,
			validate: e.validate,
			save: e.save,
			signal: n,
			validationTimeoutMs: e.validationTimeoutMs,
			timeoutMs: e.timeoutMs,
			isCurrent: () => !this.disposed && this.terminal === "READY" && this.saveCapability === "REQUIRED" && this.bridge === r
		}), this.bridge = r, this.bridgeAbort = t, e.signal) {
			let t = () => this.handleSourceAbort(r);
			this.bridgeSource = {
				bridge: r,
				signal: e.signal,
				abort: t
			}, e.signal.addEventListener("abort", t, { once: !0 });
		}
		try {
			this.host.registerBridge(r);
		} catch (e) {
			throw this.releaseBridge(r, !1), e;
		}
		if (this.bridge !== r) throw H();
		return r;
	}
	reportReady(e) {
		if (this.assertActive(), this.terminal) return;
		if (!["REQUIRED", "NONE"].includes(e) || this.context.recipientType === "CC" && e !== "NONE" || e === "REQUIRED" && !this.bridge || e === "NONE" && this.bridge !== void 0) throw V();
		let t = Object.freeze({
			pageRoute: this.pageRoute,
			saveCapability: e
		});
		this.saveCapability = e, this.terminal = "READY";
		try {
			this.host.reportReady(t);
		} catch (e) {
			throw this.terminal = void 0, this.saveCapability = void 0, e;
		}
	}
	reportFailed(e) {
		if (this.assertActive(), this.terminal) return;
		let t = e.pageRoute ?? this.pageRoute;
		if (t !== this.pageRoute || !r(t) || !/^[A-Z][A-Z0-9_]{2,63}$/.test(e.code) || !B(e.message) || typeof e.retryable != "boolean") throw V();
		this.unregisterBridge();
		let n = Object.freeze({
			pageRoute: t,
			code: e.code,
			message: e.message,
			retryable: e.retryable
		});
		this.terminal = "FAILED";
		try {
			this.host.reportFailed(n);
		} catch (e) {
			throw this.terminal = void 0, e;
		}
	}
	dispose() {
		this.disposed || (this.disposed = !0, this.unregisterBridge());
	}
	handleSourceAbort(e) {
		if (!(this.disposed || this.bridge !== e)) {
			if (this.terminal === "READY") {
				try {
					this.unregisterBridge(e);
				} catch {}
				return;
			}
			this.failFromSourceAbort();
		}
	}
	failFromSourceAbort() {
		try {
			this.reportFailed({
				code: "SDK_WORKFLOW_BRIDGE_STALE",
				message: "Workflow 工作项页面来源租约已失效",
				retryable: !1
			});
		} catch {
			this.terminal = "FAILED", this.saveCapability = void 0;
		}
	}
	unregisterBridge(e) {
		let t = this.bridge;
		!t || e && t !== e || this.releaseBridge(t, !0);
	}
	releaseBridge(e, t) {
		if (this.bridge !== e) return;
		let n = this.bridgeSource;
		n?.bridge === e && (n.signal.removeEventListener("abort", n.abort), this.bridgeSource = void 0);
		let r = this.bridgeAbort;
		this.bridgeAbort = void 0, this.bridge = void 0, r?.abort(), t && this.host.registerBridge();
	}
	assertActive() {
		if (this.disposed) throw H();
	}
	get host() {
		return this.runtimeContext.workflowPageHost;
	}
};
function z(e) {
	return new R(e);
}
function B(e) {
	return typeof e == "string" && e.length >= 1 && e.length <= 300 && e === e.trim() && !/[\r\n]/.test(e);
}
function V() {
	return new e("SDK_WORKFLOW_CAPABILITY_INVALID", "Workflow 工作项页面能力组合不完整或非法");
}
function H() {
	return new e("SDK_WORKFLOW_BRIDGE_STALE", "Workflow 工作项页面宿主已过期");
}
//#endregion
//#region src/shell/processInitiationViewHost.ts
var U = class {
	runtimeContext;
	disposed = !1;
	terminal;
	constructor(e) {
		if (this.runtimeContext = e, !e.processInitiationViewHost || !r(e.processInitiationViewHost.pageRoute) || e.workflowPageHost) throw G();
	}
	get pageRoute() {
		return this.host.pageRoute;
	}
	get context() {
		return this.host.context;
	}
	reportReady(e) {
		if (this.assertActive(), this.terminal) return;
		let t = e?.pageRoute;
		if (t !== this.pageRoute) throw G();
		this.terminal = "READY";
		try {
			this.host.reportReady(Object.freeze({ pageRoute: t }));
		} catch (e) {
			throw this.terminal = void 0, e;
		}
	}
	reportFailed(e) {
		if (this.assertActive(), this.terminal) return;
		let t = e?.pageRoute;
		if (t !== this.pageRoute || !/^[A-Z][A-Z0-9_]{2,63}$/.test(e?.code) || typeof e.message != "string" || e.message.length < 1 || e.message.length > 300 || e.message.trim() !== e.message || /[\r\n]/.test(e.message) || typeof e.retryable != "boolean") throw G();
		this.terminal = "FAILED";
		try {
			this.host.reportFailed(Object.freeze({
				...e,
				pageRoute: t
			}));
		} catch (e) {
			throw this.terminal = void 0, e;
		}
	}
	dispose() {
		this.disposed = !0;
	}
	assertActive() {
		if (this.disposed) throw new e("SDK_WORKFLOW_BRIDGE_STALE", "发起实例只读页面租约已失效");
	}
	get host() {
		return this.runtimeContext.processInitiationViewHost;
	}
};
function W(e) {
	return new U(e);
}
function G() {
	return new e("SDK_WORKFLOW_CAPABILITY_INVALID", "发起实例只读页面宿主能力组合不完整或非法");
}
//#endregion
export { S as PLATFORM_PRIMARY_NAVIGATION_SELECT_EVENT, x as PLATFORM_ROUTE_CHANGE_EVENT, M as PlatformOperationHost, C as PlatformShellBridge, U as ProcessInitiationViewHost, R as WorkflowPageHost, y as assertFormSessionOwnership, f as canonicalFormKey, c as copyFormSessionData, h as createFlowPageBridge, g as createFormSessionClient, _ as createFormSessionGuard, L as createPlatformOperationHost, W as createProcessInitiationViewHost, z as createWorkflowPageHost, u as formSessionUuid, m as guardFormSessionPageBridge, p as requireFlowPageSynchronized, v as runFormSessionOperation, o as sameFormSessionToken, i as validateDraftPageContext, l as validateFormSessionHost, d as validateFormSessionReceiver, a as validateFormSessionSnapshot, s as validateFormSessionToken };
